import { configureStore } from "@reduxjs/toolkit";
import appReducer from "../features/app/app_slice";
import communityReducer from "../features/community/community_slice";

export const store = configureStore({
  reducer: {
    app: appReducer,
    community: communityReducer,
  },
});
